import { useAuth } from 'react-oidc-context';
import { Icon } from '@/components/Icon';

interface AccessDeniedProps {
  title: string;
  message: string;
  showLogout?: boolean;
}

export function AccessDenied({ title, message, showLogout = false }: AccessDeniedProps) {
  const auth = useAuth();

  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        background: 'var(--paper)',
      }}
    >
      <div className="card" style={{ maxWidth: 460 }}>
        <div className="card-hd">
          <Icon name="alert" size={16} style={{ color: 'var(--warn)' }} />
          <div className="flex1">
            <div className="card-hd-title">{title}</div>
          </div>
        </div>
        <div className="card-pad stack gap-16">
          <div style={{ color: 'var(--ink-600)' }}>{message}</div>
          {showLogout ? (
            <div>
              <button className="btn btn-secondary" onClick={() => void auth.signoutRedirect()}>
                Sign out
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
